// Barrel export for How To Screen Record learn more block images
export { default as multiLayout } from './multiLayout.png';
export { default as editingSoftware } from './editingSoftware.png';
export { default as aiClips } from './aiClips.png';
